module.exports = __webpack_public_path__ + "static/media/55_000050.e27e1a9c.jpg";